import * as api from 'api/reports';

export const runArchivedReport = params => ({
  type: 'RUN_ARCHIVED_REPORT',
  payload: api.runArchivedReport(params),
});

export const runPrescreenReport = params => ({
  type: 'RUN_PRESCREEN_REPORT',
  payload: api.runPrescreenReport(params),
});

export const runAssessmentByQuestionTypeReport = params => ({
  type: 'RUN_QUESTION_TYPE_REPORT',
  payload: api.runAssessmentByQuestionTypeReport(params),
});

export const runCertificateOnFileReport = params => ({
  type: 'RUN_CERTIFICATE_REPORT',
  payload: api.runCertificateOnFileReport(params),
});

export const runConditionalApprovalCommentsReport = params => ({
  type: 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT',
  payload: api.runConditionalApprovalCommentsReport(params),
});

export const runIndividualRequestReport = params => ({
  type: 'RUN_INDIVIDUAL_REPORT',
  payload: api.runIndividualRequestReport(params),
});

export const runOutstandingAssessmentsReport = params => ({
  type: 'RUN_OUTSTANDING_ASSESSMENTS_REPORT',
  payload: api.runOutstandingAssessmentsReport(params),
});

export const runPendingRenewalsReport = params => ({
  type: 'RUN_RENEWALS_REPORT',
  payload: api.runPendingRenewalsReport(params),
});

export const resetState = () => ({
  type: 'RESET_REPORT_STATE',
  payload: false,
});
